import Layout from '@/views/layout/Layout'

const IndustrySolution = [
  {
    path: "/IndustrySolution",
    component: Layout,
    redirect: "solution", // 重定向到默认子路由
    children: [
      {
        path: "solution",
        component: () => import("@/views/IndustrySolution/index"),
        name: "solution",
        meta: {
          noCache: true,
        },
        }
    ],
  },
];

export default IndustrySolution